// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1LZKG","header":"MergedInvoice_header__1M16i"};